module.exports = __webpack_public_path__ + "static/3i-793b1237017aeacd646fb80911425566.woff";